<div class="marketing-area">
  <ish-content-include includeId="include.basket.base.top.pagelet2-Include" />
</div>

@if (basket$ | async; as basket) { @if (basket.lineItems.length) {
<ish-shopping-basket
  [basket]="basket"
  [error]="basketError$ | async"
  [loading]="basketLoading$ | async"
  (nextStep)="nextStep()"
/>
} @else {
<ish-shopping-basket-empty [error]="basketError$ | async" />
@if (basketLoading$ | async) {
<ish-loading />
} } } @else {
<ish-shopping-basket-empty [error]="basketError$ | async" />
@if (basketLoading$ | async) {
<ish-loading />
} }

<!-- DIAS PWA Feature: Save for Later -->
<custom-lazy-save-for-later />

<ish-lazy-recently-viewed />

<div class="marketing-area">
  <ish-content-include includeId="include.basket.base.bottom.pagelet2-Include" />
</div>
